<template>
    <div>
        <div :class="{'disabled': !isActive}">
            <a class="reward-item-a" @click="redirectToDonate">
                <div class="reward-item-box panel" style="text-align: center;">
                    <div class="col-md-12 product-image">
                        <div class="claimer" style="margin-top: 2rem; margin-bottom: 2rem">
                            <p id="entwicklerherz-title">
                                Coins Spenden
                            </p>
                            <p id="entwicklerherz-slogan">
                                Aktuelle Aktion:
                                <strong
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Mit deiner Spende unterstützt du das Projekt 'Nothilfe Ukraine' der Aktion Deutschland Hilft."
                                >
                                    Nothilfe Ukraine
                                    <i style="margin-left: 0.3rem;" class="dev-circle-info"></i>
                                </strong>
                            </p>
                        </div>
                        <button class="btn btn-entwicklerherz"
                                v-on:click="redirectToDonate()"><i
                                class="dev-heart">&nbsp;</i>Coins Spenden
                        </button>
                    </div>
                    <div class="col-12">
                        <div class="product-title">
                            &nbsp;
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
    import RewardExchangeView from "./RewardExchangeComponent";
    import {services} from "../../main.js"
    import {eventBus} from "../../main.js"

    export default {
        name: "DonationReward",
        data() {
            return {
                isActive: window.ENTWICKLER_HERZ_FEATURE_FLAG,
            }
        },
        methods: {
            redirectToDonate() {
                eventBus.$emit('open-donate-modal');
            }
        }


    }
</script>

<style scoped>
    .product-image {
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        height: 120px;
        margin-top: 3rem;
        margin-bottom: 1.5rem;
    }

    .reward-item-box {
        border-radius: 8px;
        margin: 15px 0;
        padding: 2rem 0;
        border: none;
        transition: all 200ms linear;
    }

    .product-title {
        margin: 1rem 0;
        font-size: 1.8rem;
    }

    .reward-item-a {
        text-decoration: none;
    }

    a {
        cursor: pointer;
    }

    .disabled a {
        pointer-events: none;
        cursor: default;
        text-decoration: none;
        color: black;
    }

    #entwicklerherz-title {
        color: rgb(231, 76, 60);
        font-family: 'Source Code Pro-Bold';
        margin-top: 5px;
        font-size: 2.3rem;
        margin-bottom: 3px;
    }

    #entwicklerherz-slogan {
        font-size: 1.5rem;
    }

    @media (max-width: 1370px) {
        #entwicklerherz-title {
            font-size: 1.8rem;
        }

        #entwicklerherz-slogan {
            font-size: 1.2rem;
            margin: 0 auto;
        }
    }

    @media (max-width: 1199px) {
        #entwicklerherz-title {
            font-size: 2.3rem;
        }

        #entwicklerherz-slogan {
            font-size: 1.5rem;
            margin: 0 auto;
        }
    }
</style>
